const contentPath = require('@truqc/content-path');
const path = require('path');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  getFormContent
} = require('../lib/getFormContent');

/**
  * @function evaluate - expand references in an object
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);

  // if thre's no object, then skip expansion
  if (!value) return undefined;
  const getForm = async uuid => getFormContent(uuid, content, parentContentPath, transientContext, nativeFunctions);
  const forms = {};
  const iterateOverFormReferences = (obj = {}, itParentContentPath = '/') => {
    Object.keys(obj).forEach(key => {
      // we don't want traverse back up the tree to the parentForm, only down the tree
      if (key === '_formRef' && itParentContentPath.split('/').pop() !== 'parentForm') {
        // first time we see a _formRef, we can assume this is this is a formRef
        forms[obj[key]] = forms[obj[key]] && forms[obj[key]].contentPaths ? {
          contentPaths: [...forms[obj[key]].contentPaths, itParentContentPath]
        } : {
          contentPaths: [itParentContentPath]
        };
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        const formRefContentPath = path.join(itParentContentPath, key);
        iterateOverFormReferences(obj[key], formRefContentPath);
      }
    });
  };
  iterateOverFormReferences(value, '/');

  // Retrieve all form refs found. Promise.all deadlocks
  /* eslint-disable no-restricted-syntax */
  for (const formID of Object.keys(forms || {})) {
    try {
      /* eslint-disable-next-line no-await-in-loop */
      const form = await getForm(formID);
      if (Object.keys(form).length > 0) forms[formID].form = form;
    } catch (e) {
      /* eslint-disable-next-line no-console */
      console.log(`Error in shallowExpandReferencesBehavior: Unable to find form by id: ${formID}`, e.debugMessage);
    }
  }

  // Attach the expanded forms to their _formRef
  Object.keys(forms).forEach(key => {
    const {
      form: formContent,
      contentPaths
    } = forms[key];
    contentPaths.forEach(savePath => {
      value = contentPath.setContentValue(savePath, value, formContent);
    });
  });
  return value;
};
module.exports = {
  evaluate
};